import {useEffect, useReducer} from 'react'
import {sendRequestAuth} from 'api/api'
import {
    useCreateTeacherAction,
    useCreateTeacherReducer,
} from '../provider/_reducer'
import config from "../../../../../config";
import {formatDatetimeV2} from "../../../../../common/form/datePicker/_functions";
import {CREATE_TEACHER_GENDER, STATUS_TEACHER, TAB_CREATE_TEACHER_EDIT} from "../interfaces/constant";
import {useParams, useSearchParams} from "react-router-dom";
import {useCreateTeacherInitialState} from "../provider/_initState";
import {useCreateProductAction, useModalProductAction} from "../provider/_action";
import INFO_BANKS from 'util/_vietnam_banks';
import DATA_ADDRESS from "util/_data.json";
import { formatNumber } from 'util/formatNumber';

const useCreateTeacher = () => {
    const [state, dispatch] = useReducer(useCreateTeacherReducer, useCreateTeacherInitialState)
    const [searchParams] = useSearchParams()
    const {teacherId} = useParams()
    useEffect(() => {
        if (searchParams.get('tab') === 'products')
            dispatch({type: useCreateTeacherAction.FORM_CREATE_TAB_CHANGE, payload: TAB_CREATE_TEACHER_EDIT[1]})
    }, [searchParams])

    const handleOriginFetch = async (id) => {
        const response = await Promise.all([
            sendRequestAuth('get', `${config.API}/principal/teacher/detail/${id}`),
            sendRequestAuth('get', `${config.API}/product-category/filter-commission-for-parent?type=digital&user_id=${id}`),
        ])
        if (response[0]?.data?.success) {
            const detail = response[0]?.data?.data
            dispatch({
                type: useCreateTeacherAction.FORM_CREATE_GET_DETAIL,
                payload: {
                    info: {
                        userName: {
                            value: detail?.username || '',
                            status: false,
                            message: ''
                        },
                        schoolName: {
                            value: detail?.school_name || '',
                            status: false,
                            message: ''
                        },
                        phone: {
                            value: detail?.phone || '',
                            status: false,
                            message: ''
                        },
                        email: {
                            value: detail?.email || '',
                            status: false,
                            message: ''
                        },
                        name: {
                            value: detail?.name || '',
                            status: false,
                            message: ''
                        },
                        lastName: {
                            value: detail?.last_name || '',
                            status: false,
                            message: ''
                        },
                        birthday: {
                            value: !!detail?.birthday ? formatDatetimeV2(detail?.birthday) : '',
                            status: false,
                            message: ''
                        },
                        identify: {
                            value: detail?.identity_number || '',
                            status: false,
                            message: ''
                        },
                        identityFront: {
                            value: detail?.identity_front || ''
                        },
                        identityBack: {
                            value: detail?.identity_back || ''
                        },
                        contract: {
                            value: detail?.contract_link || ''
                        },
                        province: {
                            value: DATA_ADDRESS?.find(item => item.name === detail?.province) || '',
                            list: DATA_ADDRESS,
                            listOrigin: DATA_ADDRESS
                        },
                        commission: {
                            value: detail?.commission_rate || '',
                            status: false,
                            message: ''
                        },
                        teachingSubject: {
                            value: detail?.teaching_subject || '',
                            status: false,
                            message: ''
                        },
                        gender: {
                            value: CREATE_TEACHER_GENDER?.find(find => find.value === detail?.gender),
                            status: false,
                            message: ''
                        },
                        address: {
                            value: detail?.address,
                            status: false,
                            message: ''
                        },
                        password: {
                            value: '',
                            status: false,
                            message: ''
                        },
                        statusPerson: {
                            value: STATUS_TEACHER?.find(find => find.value === detail?.status),
                            status: false,
                            message: ''
                        },
                        accountNumber: {
                            value: detail?.bank_number,
                            status: false,
                            message: ''
                        },
                        accountOwner: {
                            value: detail?.bank_owner,
                            status: false,
                            message: ''
                        },
                        bankName: {
                            value: { id: '999', name: detail?.bank_name},
                            status: false,
                            list: INFO_BANKS,
                            listOrigin: INFO_BANKS
                        },
                        avatar: {
                            value: detail?.avatar || ''
                        },
                        detail: detail
                    }
                }
            })
        }
        if(response[1]?.data?.success) {
            dispatch({
                type: useCreateProductAction.TABLE_UPDATE_CATEGORY_COMMISSION_LIST,
                payload: {
                loading: false,
                list: response[1]?.data?.data?.map(item => {
                    return {
                        ...item,
                        teacher_commission_manager: formatNumber(item.teacher_commission_manager || 0),
                        teacher_commission_principal: formatNumber(item.teacher_commission_principal || 0)
                    }
                })
                }
            })
        }

        const res = await Promise.all([
            sendRequestAuth('get', `${config.API}/product-category/group-categories?type=digital&is_parent=0`),
        ])
        if(res[0]?.data?.length > 0) {
            dispatch({
                type: useCreateProductAction.FILTER_CATEGORY_LIST_ORIGIN_UPDATE,
                payload: {
                    list: res[0]?.data,
                    listOrigin: res[0]?.data
                }
            })
            dispatch({
                type: useModalProductAction.FILTER_CATEGORY_LIST_ORIGIN_UPDATE,
                payload: {
                    list: res[0]?.data,
                    listOrigin: res[0]?.data
                }
            })
        }
    }


    return {
        fetch: {
            origin: handleOriginFetch
        },
        provider: {
            state,
            dispatch
        },

    }
}
export default useCreateTeacher